import styled from 'styled-components'
export const Wrapper = styled.div`
  font-family: inter;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    height: auto;
    margin-top: 30px;
  }
`
export const LoginWrapper = styled.div`
  width: 50% !important;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100% !important;
    height: auto;
  }
  .welcome {
    display: flex;
    width: 100%;
    align-items: center;
    padding: 0px 100px;
    padding-top: 50px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding: 0px 20px;
    }
    .step {
      display: flex;
      align-items: center;
      padding-left: 70px;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        padding-left: 0px;
        flex-direction: column;
      }
      img {
        @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
          width: 40%;
        }
      }
      .details {
        padding-left: 10px;
        @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
          padding-top: 20px;
          padding-left: 70px;
        }
      }

      p {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.CardDark};
        margin-top: -13px;
      }
      .step-topic {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #292d32;
      }
    }

    h1 {
      font-style: normal;
      font-weight: 600;
      font-size: 36px;
      line-height: 40px;
      letter-spacing: 0.25px;
      color: ${({ theme }) => theme.colors.Cmk};
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 24px !important;
      }
    }
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 32px;
      letter-spacing: -0.048px;
      color: ${({ theme }) => theme.colors.DarkCyan};
      margin-top: -17px;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 14px;
      }
    }
  }
`
export const FormWrapper = styled.form`
  width: 100%;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    margin-bottom: 300px;
  }
  .name {
    display: flex;
    align-items: center;
    padding: 0px 100px;
    width: webkit-fill-available;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding: 0px 20px;
    }
    .each-form-name {
      margin-bottom: 40px;
      display: flex;
      flex-direction: column;
      width: 50%;
    }
    .lefty {
      margin-left: 30px;
    }
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
  .each-form {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    padding: 0px 100px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding: 0px 20px;
    }
    .to-left {
      text-align: center;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.secondPrimary};
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 12px;
      }
    }
    span {
      color: ${({ theme }) => theme.colors.black};
    }
  }
  .revert {
    margin-top: -0px;
  }
  label {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.DarkCyan};
    padding-bottom: 10px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: 12px;
    }
  }
`

export const PasswordContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  img {
    position: absolute;
    left: 10px;
    cursor: pointer;
  }
  .number {
    padding-left: 115px;
  }
`
